module.exports = __webpack_public_path__ + "img/acorn_barnicle.c2785297.png";